var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.376 28.002c-7.475.147-15.469 2.625-21.11 5.318-12.971 6.287-26.097 18.123-36.622 32.412-10.526 14.29-18.463 30.992-21.854 46.35-3.371 15.272-2.164 28.759 3.705 38.08l89.178 117.861c-.323-1.676-.62-3.362-.877-5.062-4.594-30.313.962-64.488 17.356-95.967 16.393-31.479 40.677-54.6 67.261-66.51 9.26-4.148 18.853-6.918 28.473-8.152l-110.045-60.43c-5.044-2.575-10.19-3.83-15.465-3.9zm138.156 81.95c-11.029-.138-22.48 2.414-33.81 7.49-22.66 10.15-44.375 30.513-59.059 58.708-14.684 28.196-19.4 58.59-15.484 84.428 3.916 25.839 16.127 46.774 35.404 58.152 11.198 6.61 23.703 9.352 36.658 8.504-5.197-12.722-9.295-25.665-9.841-39.318 10.304-19.968 20.802-39.936 35.695-59.905 22.946-7.223 47.124-4.533 75.035-3.39 3.722-16.605 4.335-32.99 2.08-47.863-3.916-25.839-16.127-46.774-35.404-58.153-9.638-5.689-20.244-8.516-31.273-8.654zm71.481 132.306l-67.496 3.863 18.369 61.832 66.26-3.715c-2.435-21.315-10.232-41.558-17.133-61.98zm-80.666 15.195c-7.923 9.763-14.526 20.318-17.787 32.877 1.772 19.22 4.134 38.373 14.185 56.672l18.39-30.13zm173.738 59.95c-24.604 11.259-43.699 23.436-62.822 35.609l70.945 55.69 67.86-48.368c-22.714-15.182-47.656-29.62-75.983-42.932zm-82.357 6.152l-62.108 2.92-18.431 29.722c19.703-.995 38.332.695 59.717-4.502 10.37-9.38 14.824-18.76 20.822-28.14zm14.894 48.601c-5.018 19.188-5.258 39.333-5.73 59.43 17.198 23.68 40.384 36.581 61.943 52.412l8.658-62.232zm142.354 9.223l-58.973 42.498-8.88 56.496c19.434-11.58 37.82-24.417 52.605-41.574 8.266-19.14 11.495-38.28 15.248-57.42z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.b2cc64a20394ba147ee39dcc11796fa1.svg";
export { ForwardRef as ReactComponent };